import React from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {useDispatch} from 'react-redux';
import {t} from '@lingui/core/macro';

import {webhookAPI, IWebhookAdd} from 'entities/notification';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import InputText from 'shared/ui/Input/InputText';
import InputUrl from 'shared/ui/Input/InputUrl';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import {validateDescription} from 'features/profile/lib/validateDescription';
import {fetchMe} from 'entities/user';
import {TypedDispatch} from 'shared/model/types';

interface IWebhookFormProps {
    onSuccess: () => void,
    onClose: () => void,
}

const WebhookForm: React.FC<IWebhookFormProps> = ({onSuccess, onClose}) => {
    const {register, handleSubmit, formState, control, watch} = useForm<IWebhookAdd>({mode: 'onChange'});
    const {errors} = formState;

    const urlValue = watch('url');
    const descriptionValue = watch('description');
    const isFormValid = urlValue?.trim() && descriptionValue?.trim();

    const dispatch = useDispatch<TypedDispatch>();
    const [addWebhook, {isLoading}] = webhookAPI.useAddMutation();

    const onSubmit: SubmitHandler<IWebhookAdd> = async(data) => {
        const result = await addWebhook({
            url: data.url.trim(),
            description: data.description.trim(),
        });
        if ('error' in result) return;
        dispatch(fetchMe());
        onSuccess();
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ModalBodyWrapper>
                <FormGroupWithError
                    error={errors?.url?.message}
                    label="URL"
                >
                    <InputUrl
                        control={control}
                        name="url"
                        placeholder="https://example.com/hooks/overseer"
                        register={register}
                    />
                </FormGroupWithError>

                <FormGroupWithError
                    error={errors?.description?.message}
                    label={t`Описание`}
                >
                    <InputText
                        control={control}
                        name="description"
                        placeholder={t`Краткое описание`}
                        register={register}
                        validate
                        rules={{
                            required: t`Описание обязательно для заполнения`,
                            validate: validateDescription,
                        }}
                    />
                </FormGroupWithError>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={t`Добавить`}
                primaryButtonType="submit"
                primaryButtonLoading={isLoading}
                primaryButtonDisabled={!isFormValid || isLoading}
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
};

export default WebhookForm;
